import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UpdateRecordGuard implements CanActivate {
  private http = inject(HttpClient);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const page = route.queryParams['page'] || 'licenses';
    const individualId = route.queryParams['individualId'];

    return this.http
      .post<any>(
        environment.urls.dataServicesGraphql,
        {
          query: `query createPrepopulatedFiling($individualEntityId: Float!) {
  createPrepopulatedFiling(getFilingParams: {subjectId: $individualEntityId}) {
    decafId
  }
}`,
          variables: { individualEntityId: Number(individualId) },
        },
        { withCredentials: true, headers: { 'Content-Type': 'application/json' } },
      )
      .toPromise()
      .then((resp) => {
        const decafId = resp?.data?.createPrepopulatedFiling?.decafId;
        if (decafId) {
          this.router.navigate(['view', 'dataEntry', 'section', page], {
            queryParams: { instanceId: decafId },
          });
        } else {
          this.router.navigate(['/error']);
        }
        return false;
      })
      .catch(() => {
        this.router.navigate(['/error']);
        return false;
      });
  }
}
